import { Map } from "@vis.gl/react-google-maps";
import { useMemo } from "react";
import { mapChromeShell } from "../../../../styles/mapChromeShell";

function BaseMap({ defaultCenter, defaultZoom, mapID, isEditable, onClick, children }) {
    // 改善: メモ化されたオプションでパフォーマンス向上
    const mapOptions = useMemo(() => ({
        // 改善: 3D表示を無効化（パフォーマンス向上）
        tilt: 0, // 45から0に変更
        heading: 0,
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: true,
        // 改善: 不要なコントロールを無効化（3D無効化に合わせて）
        rotateControl: false, // trueからfalseに変更
        fullscreenControl: true,
        draggableCursor: isEditable ? "crosshair" : "default",
        optimized: true,
        suppressMarkers: false,
    }), [isEditable]);

    return (
        <Map
            className={mapChromeShell.map}
            defaultCenter={defaultCenter}
            defaultZoom={defaultZoom}
            disableDefaultUI={false}
            mapTypeId="satellite"
            mapId={mapID}
            clickableIcons={false}
            gestureHandling="greedy"
            onClick={onClick}
            options={mapOptions}
        >
            {children}
        </Map>
    );
}

export default BaseMap;
